import { useEffect } from 'react'
import A from 'utils/metrics/analytic'

enum originReg {
  INTRO = 'intro',
  WEBINAR_LIST = 'webinar_list',
  WEBINAR_FUTURE = 'webinar_future',
  WEBINAR_PAST = 'webinar_past',
  LIBRARY = 'library',
  ARTICLE = 'article',
  VIDEO = 'video',
  PODCAST = 'podcast',
  INTERACTIVE = 'interactive',
  CLINICAL_LIST = 'clinical_list',
  CLINICALCASE = 'clinicalcase',
  CALCULATORS = 'calculators',
}

enum originRegMain {
  JOIN_MAIN = 'joinmain',
  COMMUNITY = 'community',
}

enum originRegWebinars {
  LOGIN = 'login',
  SUBWEBINARS = 'subwebinars',
  SUBFUTURE = 'subfuture',
  COMMENT = 'comment',
  SUBREC = 'subrec',
  LOGINPAST = 'loginpast',
  SUBLECTOR = 'sublector',
}

enum originAIBOLIT {
  AIBOLITTRY = 'aibolittry',
  AIBOLITUSE = 'aibolituse',
}

enum originMedpulse {
  JOINTOP = 'jointop',
  JOINMIDDLE = 'joinmiddle',
  JOINBOTTOM = 'joinbottom',
  LOGIN = 'login',
}

enum originCourse {
  LOGINCOURSE = 'logincourse',
  LOGIN = 'login',
  LOGINPAY = 'loginpay',
}

const A_LOG_REG_KEY = 'A_LOG_REG_KEY'
const A_LOG_REG_HASH = 'A_LOG_REG_HASH'

const A_openRegAndLogin = (path: string) => {
  const origin = sessionStorage.getItem(A_LOG_REG_KEY)
  if (origin) A.setEvent('signin_click', { origin, path })
}

const A_openRegAndLogin2 = () => {
  const origin = sessionStorage.getItem(A_LOG_REG_HASH)
  const path = origin
    ? window.location.href + '&' + origin
    : window.location.href + '&' + 'autorization'
  A.setEvent('signin_click', { path })
  setTimeout(() => {
    sessionStorage.removeItem(A_LOG_REG_HASH)
  }, 1000)
}

const A_clickRegAndLogin = (path: string) => {
  A.setEvent('signin_click', { path })
}
// Прогресс реги
enum stepRegProgress {
  PHONE = 'phone',
  EMAIL = 'email',
  EMAIL_CLICK = 'email_click',
  NO_PHONE = 'no_phone',
  FOREIGN = 'foreign',
}
const A_signinProgress = (step: stepRegProgress) => {
  A.setEvent('signin_progress', { step })
}
// Ошибки
enum stepErrors {
  WRONG_CODE = 'wrong_code',
  REQUEST_CODE = 'request_code',
  LIMITS_CODE = 'limits_code',
}
const A_signinErrors = (name: stepErrors, type: 'phone' | 'email') => {
  A.setEvent('signin_errors', { name, type })
}

// Успешная Авторизация
enum succesSignin {
  PHONE = 'phone',
  EMAIL = 'email',
  FOREIGN = 'foreign',
}
const A_signinSucces = (type: succesSignin) => {
  A.setEvent('signin_success', { type })
}

// Успешная Регистрация

const A_regFinish = (path: string, ad: boolean) => {
  A.setEvent('registration_finish', { page_path: path, ad_box: String(ad) })
}

// Старт Реги
const A_startReg = () => {
  A.setEvent('registration_start')
}
// ПОпап с просьбой указать до инфу после реги
const A_personalInfoShow = () => {
  A.setEvent('personal_info_shown')
}

// ПОпап с просьбой указать до инфу после реги (Юзер сохранил данные)
const A_personalInfoSucces = () => {
  A.setEvent('personal_info_success')
}

// Хук - который задает ориджн ( ЕГо нужн вызывать на каждой странице отдельно)
const useARegAndLogin = (origin: originReg) => {
  useEffect(() => {
    const initAInfo = () => {
      sessionStorage.setItem(A_LOG_REG_KEY, origin)
    }

    initAInfo()

    const deleteAInfo = () => {
      sessionStorage.removeItem(A_LOG_REG_KEY)
    }

    return deleteAInfo
  }, [origin])
}

export {
  A_openRegAndLogin,
  A_signinProgress,
  A_signinErrors,
  A_signinSucces,
  A_startReg,
  A_regFinish,
  A_personalInfoShow,
  A_personalInfoSucces,
  A_clickRegAndLogin,
  A_openRegAndLogin2,
  useARegAndLogin,
  A_LOG_REG_HASH,
  originReg,
  originRegWebinars,
  originAIBOLIT,
  originMedpulse,
  originCourse,
  stepRegProgress,
  stepErrors,
  succesSignin,
  originRegMain,
}
